import PropTypes from "prop-types";
import React from "react";
import ReactDatePicker from "react-datepicker";

import FormInputError from "../formInputGroups/FormInputError";

function DatePicker(props) {
  const { label, formik, name, placeholderText, onChange, className, showError, ...rest } = props;
  return (
    <div className={className}>
      {label && <p>{label}</p>}
      <ReactDatePicker
        wrapperClassName="rjs-datepicker"
        showPopperArrow={false}
        onChange={
          onChange
            ? onChange
            : (e) => {
                formik?.setFieldValue(name, e);
              }
        }
        placeholderText={placeholderText}
        {...rest}
      />
      {showError && <FormInputError formik={formik} name={name} />}
    </div>
  );
}

export const defaultProps = {
  className: "",
  label: "",
};

export const propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholderText: PropTypes.string,
  dateFormat: PropTypes.string,
  locale: PropTypes.string,
  filterDate: PropTypes.func,
  filterTime: PropTypes.func,
  popperClassName: PropTypes.string,
  popperPlacement: PropTypes.string,
  selected: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  onchange: PropTypes.func,
  onChangeRaw: PropTypes.func,
  calenderContainder: PropTypes.element,
  onCalendarClose: PropTypes.func,
  onCalendarOpen: PropTypes.func,
  children: PropTypes.element,
  customInput: PropTypes.element,
  isClearable: PropTypes.bool,
  disabled: PropTypes.bool,
  showTimeInput: PropTypes.bool,
  showTimeSelect: PropTypes.bool,
  closeOnScroll: PropTypes.func,
  renderCustomHeader: PropTypes.func,
  selectsRange: PropTypes.bool,
  inline: PropTypes.bool,
  selectsDisabledDaysInRange: PropTypes.bool,
  excludeDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  excludeDateIntervals: PropTypes.arrayOf(PropTypes.object),
  excludeTimes: PropTypes.arrayOf(PropTypes.object),
  showDisabledMonthNavigation: PropTypes.bool,
  withPortal: PropTypes.bool,
  disabledKeyboardNavigation: PropTypes.bool,
  shouldCloseOnSelect: PropTypes.bool,
  fixedHeight: PropTypes.bool,
  showError: PropTypes.bool,
  formik: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

DatePicker.propTypes = propTypes;
DatePicker.defaultProps = { ...defaultProps, type: PropTypes.string };

export default DatePicker;
